<div class="step-title">
  <button matIconButton type="button" aria-label="Indietro" (click)="flow.back()">
    <i class="fa-regular fa-arrow-left" aria-hidden="true"></i>
  </button>
  @if (detail(); as detail) {
    <span class="headline-small-emphasized">{{ detail.ragioneSociale }}</span>
  }
</div>

@if (detail(); as detail) {
  <div class="card-list">
    <mat-expansion-panel class="detail-panel" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title-medium-emphasized">Dati anagrafici</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="detail-rows">
        <div class="detail-row"><span class="body-medium">Ragione sociale</span><span class="body-medium-emphasized">{{ detail.ragioneSociale }}</span></div>
        <div class="detail-row"><span class="body-medium">Codice fiscale</span><span class="body-medium-emphasized">{{ detail.codiceFiscale || '—' }}</span></div>
        <div class="detail-row"><span class="body-medium">Partita IVA</span><span class="body-medium-emphasized">{{ detail.partitaIva || '—' }}</span></div>
        <div class="detail-row"><span class="body-medium">Codice Ateco</span><span class="body-medium-emphasized">{{ detail.codiceAteco || '—' }}</span></div>
        <div class="detail-row"><span class="body-medium">Descrizione Ateco</span><span class="body-medium-emphasized">{{ detail.descrizioneAteco || '—' }}</span></div>
        <div class="detail-row"><span class="body-medium">Data costituzione</span><span class="body-medium-emphasized">—</span></div>
        <div class="detail-row"><span class="body-medium">Forma giuridica</span><span class="body-medium-emphasized">{{ detail.formaGiuridica || '—' }}</span></div>
        <div class="detail-row">
          <span class="body-medium">Stato attività</span>
          @if (detail.statoAzienda) {
            <span class="chip chip--success label-small">{{ detail.statoAzienda }}</span>
          } @else {
            <span class="body-medium-emphasized">—</span>
          }
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel class="detail-panel" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title-medium-emphasized">Sede legale</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="detail-rows">
        <div class="detail-row"><span class="body-medium">Indirizzo</span><span class="body-medium-emphasized">{{ detail.indirizzo || '—' }}</span></div>
        <div class="detail-row"><span class="body-medium">CAP</span><span class="body-medium-emphasized">{{ detail.cap || '—' }}</span></div>
        <div class="detail-row"><span class="body-medium">Comune</span><span class="body-medium-emphasized">{{ detail.comune || '—' }}</span></div>
        <div class="detail-row"><span class="body-medium">Provincia</span><span class="body-medium-emphasized">{{ detail.provincia || '—' }}</span></div>
        <div class="detail-row"><span class="body-medium">Nazione</span><span class="body-medium-emphasized">{{ detail.nazione || '—' }}</span></div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel class="detail-panel" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title-medium-emphasized">Altri dati</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="detail-rows">
        <div class="detail-row"><span class="body-medium">PEC</span><span class="body-medium-emphasized">{{ detail.pec || '—' }}</span></div>
        <div class="detail-row"><span class="body-medium">Sito web</span><span class="body-medium-emphasized">—</span></div>
      </div>
    </mat-expansion-panel>
  </div>
} @else if (failed()) {
  <div class="step-empty body-large">Il servizio al momento non risponde. Riprova più tardi.</div>
} @else {
  <div class="loading-row"><ui-loading-spinner /></div>
}

<div class="step-actions">
  <button matButton="filled" type="button" [disabled]="!detail() || flow.loading()" (click)="confirm()">Seleziona</button>
</div>
